export const DEFAULT_OPACITY = 1;
export const HEX_COLOR_PATTERN = '^#(?:[A-Fa-f0-9]{3,4}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$';
//# sourceMappingURL=constants.js.map